import premiumOnlyImg from "../../assets/images/locationcreation/premiumOnly.png";

const PremiumOnlyImage = (props: any) => {
  return <img src={premiumOnlyImg} alt="Premium Only" style={props.style ?? {}} />;
};
export default PremiumOnlyImage;